<mat-form-field class="w-100">
	<mat-chip-list #chipList>
		<mat-chip
			*ngFor="let chip of chips"
			selectable="false"
			[removable]="removable"
			(removed)="remove(chip)"
		>
			{{ chip }}
			<mat-icon *ngIf="removable" matChipRemove>cancel</mat-icon>
		</mat-chip>
		<input
			[required]="required"
			[disabled]="!removable"
			autocomplete="off"
			[placeholder]="placeholder"
			[matChipInputFor]="chipList"
			[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
			matChipInputAddOnBlur="true"
			(matChipInputTokenEnd)="add($event)"
		/>
	</mat-chip-list>
</mat-form-field>
